import { render, staticRenderFns } from "./CampaignCreativesVTRPage.vue?vue&type=template&id=bd79f988&"
import script from "./CampaignCreativesVTRPage.vue?vue&type=script&lang=js&"
export * from "./CampaignCreativesVTRPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports